<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div >
                        <h5 class="pb-2">تغيير كلمة المرور</h5>

    
                    </div>
                    <ng-template >
                        
                    </ng-template>
                </div>
                <div class="card-body">
                    <form class="needs-validation" autocomplete="off" 
                    [formGroup] = "changepasswordForm"
                    (ngSubmit)="onSubmit()" 
                    novalidate>
                        <div class="form-row">
                           
                            <!-- current password       -->
                            <div class="col-6 mb-3">
                                <label for="validation03"><span class="validation-required">*</span> كلمة المرور الحالية</label>
                                <input class="form-control" id="validation03" type="text" formControlName="currentPassword"
                                [tooltip]="fc.currentPassword.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.currentPassword.valid && (fc.currentPassword.touched)"
                                [class.is-invalid]="fc.currentPassword.invalid && (fc.currentPassword.touched)"
                                     required
                                     placeholder="كلمة المرور الحالية"
                                    containerClass="" 
                                    />
                            </div>
                            <!-- new password       -->
                            <div class="col-6 mb-3">
                                <label for="validation03"><span class="validation-required">*</span> كلمة المرور الجديدة</label>
                                <input class="form-control" id="validation03" type="text" formControlName="newPassword"
                                [tooltip]="fc.newPassword.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.newPassword.valid && (fc.newPassword.touched)"
                                [class.is-invalid]="fc.newPassword.invalid && (fc.newPassword.touched)"
                                     required
                                     placeholder="كلمة المرور الجديدة"
                                    containerClass="" 
                                    />
                            </div>
                               
                       </div>
                       <button  class="btn pull-right" type="submit">
                        حفظ
                     </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>



